export default "__VITE_ASSET__CGT7PeQa__"